<template>
  <div class="klick-modal-wrapper" v-if="boxConfig.trigger_button.kind === 'external'">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <i style="font-size:30px; color:#6B8A99;" class="fa fa-info-circle"></i>
          <h4 style="color: #6B8A99; font-weight: bold; margin-top: 16px;">{{ $t('edit.canvas.external_button') }}</h4>
        </div>

        <div class="modal-body" style="text-align: left">
          <div>
            <h4 class="help-block"><b>{{ $t('general.labels.step') }} 1:</b> {{ $t('edit.canvas.click_button') }} <b>{{ $t('general.actions.export') }} <i class="kp-panel-import"></i></b>.</h4>
          </div>
          <div>
            <h4 class="help-block"><b>{{ $t('general.labels.step') }} 2:</b> {{ $t('edit.canvas.copy_the') }} <b>{{ $t('edit.canvas.box_code') }}</b> {{ $t('edit.canvas.past_in_your_page') }}.</h4>
          </div>
          <div>
            <h4 class="help-block"><b>{{ $t('general.labels.step') }} 3:</b> {{ $t('edit.canvas.copy_the') }} <b>{{ $t('edit.canvas.call_button_code') }}</b> {{ $t('edit.canvas.add_to_link_or_button') }}.</h4>
          </div>
        </div>

        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** External.vue?285d1107
 **/